module.exports = __webpack_public_path__ + "img/tax-password-example.5fb2a586.png";